// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */
import React from "react";
import {Button} from "reactstrap";
import type {Caller} from "../QueryPage";

export type SsoActionButtonStateProps = {
    disabled?: boolean,
    isLoading?: boolean,
    caller: Caller,
    roleIds: Array<string>
};

export type SsoActionButtonDispatchProps = {

    onClickAction: (ssoUid: string, caller: Caller, roleIds: Array<string>) => any
};

export type SsoActionButtonOwnProps = {
    ssoUid: string,
    label: string,
    loadingComponent?: React.Component<any> | string | () => React.Component<any>
};

type SsoActionButtonProps = SsoActionButtonOwnProps & SsoActionButtonStateProps & SsoActionButtonDispatchProps;

export default function SsoActionButton(props: SsoActionButtonProps) {

    const {label, ssoUid, isLoading, loadingComponent, onClickAction, caller, roleIds, ...rest} = props;
    const onClick = onClickAction ? () => {
        onClickAction(ssoUid, caller, roleIds);
    } : undefined;
    return <Button onClick={onClick} {...rest}>{isLoading && loadingComponent ? loadingComponent : label}</Button>;
};


// WEBPACK FOOTER //
// ./src/components/sso/SsoActionButton.js